const ObservationModal = (params) =>{
    const {value, data, observationRender} = params;

    return (
        <>
            <div className={"w-full h-full min-h-[32px] absolute top-0 left-0 mx-1"} onClick={() => observationRender(data, value)}>
                <p>{value}</p>
            </div>
        </>
    );
};

export default ObservationModal;
